@if (!config.showLoader) {
    @if (invalidConfig) {
        <div class="centered-text">
            <span>{{ 'embeddedReportWidget.noReportSelected' | t }}</span>
        </div>
    } @else if (waitInput) {
        <div class="centered-text input-actions">
            <div class="buttons">
                <button class="btn btn-primary" (click)="waitInput = false">
                    <i class="fas fa-file-download"></i>
                    <span>{{ 'embeddedReportWidget.loadReportButton' | t }}</span>
                </button>

                <button class="btn btn-dark" (click)="openReport()">
                    <i class="fas fa-external-link-alt"></i>
                    <span>{{ 'embeddedReportWidget.openReportButton' | t }}</span>
                </button>
            </div>
        </div>
    } @else if (reportID) {
        <report-powerbi [id]="reportID"></report-powerbi>
    }
}
